import { AxiosPromise } from 'axios';
import { BulkUpdateInvitedPersonsRequest } from '../models/invitation/BulkUpdateInvitedPersonsRequest';
import { InvitedPersonDto } from '../models/invitation/InvitedPersonDto';
import { OneTimePersonDto } from '../models/invitation/OneTimePersonDto';
import { UpdateInvitedPersonRequest } from '../models/invitation/UpdateInvitedPersonRequest';
import { resources } from '../resources';
import { CrudService } from './CrudService';

export class InvitationPersonService extends CrudService<InvitedPersonDto, Record<string, unknown>, InvitedPersonDto | UpdateInvitedPersonRequest> {
  constructor() {
    super({
      query: resources.queryPersons,
      create: resources.addPerson,
      update: resources.updatePerson,
      delete: resources.deletePerson,
      idKey: 'personId',
    });
  }

  public overridePersonRequirements(invitationId: string, personId: string): AxiosPromise<void> {
    return this.put<void>(resources.overridePersonRequirements, undefined, { invitationId, personId });
  }

  public resendNotification(invitationId: string, personId: string): AxiosPromise<void> {
    return this.put<void>(resources.resendNotification, undefined, { invitationId, personId });
  }

  public bulkUpdatePersons(invitationId: string, body: BulkUpdateInvitedPersonsRequest): AxiosPromise<void> {
    return this.put<void>(resources.bulkUpdatePersons, body, { invitationId });
  }

  public addOneTimePerson(invitationId: string, body: OneTimePersonDto): AxiosPromise<InvitedPersonDto> {
    return this.post<InvitedPersonDto>(resources.addOneTimePerson, body, { invitationId });
  }
}
